import { Button } from "@/components/chadcn/Button"
import { useNavigate } from "react-router"

type BackButtonProps = {
  title?: string
  customClickHandler?: () => void
}

const BackButton = ({ title = "Back", customClickHandler }: BackButtonProps) => {
  const navigate = useNavigate()
  const onClick = customClickHandler ?? (() => navigate(-1))

  return (
    <Button type="button" size="sm" onClick={onClick} className="w-fit min-w-20 px-4 text-sm">
      {title}
    </Button>
  )
}

export default BackButton
